module.exports = __webpack_public_path__ + "img/round-email-24px.19800b90.svg";